import { HttpHeaders } from '@angular/common/http';
import { ITabItemView, IUserProfile } from 'gadoe-framework';

export class Config {
  static appSettings: any;
  static ROOT_URL = '';
  static FRAMEWORK_URL = '';
  static LOGIN_URL = '';
  static calculatorInquiryFormUrl = '';
  static logValue = 0;

  static userProfile: IUserProfile;
  static adminRole: boolean;

  static selectedTabMenuItem: ITabItemView;

  static httpHeaders = new HttpHeaders()
    .set('Accept', 'application/json')
    .set('Content-Type', 'application/json');

  static selectedTab = 0;
}